function Chapter(props) {   
    return (
        <section className={"chapter " + (props.specialClass ? "chapter__special" : "") + " "}>
            <h2 className="chapter__title">
                {
                    props.chapter.type
                }
            </h2>
            {
                props.chapter.items.map((position, positionIndex)=>{
                    return (
                        <div className="chapter__position" key={"position" + positionIndex}>
                            <div className="chapter__img__wrapper">
                                <img 
                                    className="chapter__img"
                                    alt={position.name}
                                    src={position.img}
                                />
                            </div>
                            <div className="chapter__description">
                                <div className="chapter__text">
                                    <p className="chapter__name">
                                        {position.name}
                                    </p>
                                    <p className="chapter__composition">
                                        {position.composition}
                                    </p>
                                </div>
                                <p className="chapter__cost">
                                    {position.cost + " ₽"}
                                </p>
                            </div>
                        </div>
                    )
                })
            }
        </section>
    );
}

export default Chapter;